import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.partner.user.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_PARTNER_USER_ASYNC: `${uid}.savePartnerUserAsync`,
    SAVE_PARTNER_USER_SUCCESS: `${uid}.savePartnerUserSuccess`,
    SAVE_PARTNER_USER_FAILURE: `${uid}.savePartnerUserFailure`,
    CREATE_PARTNER_USER: `${uid}.createPartnerUser`,
    UPDATE_IS_CREATED: `${uid}.updateIsCreated`,
    CREATE_PARTNER_USER_ASYNC: `${uid}.createPartnerUserAsync`,
    CREATE_PARTNER_USER_SUCCESS: `${uid}.createPartnerUserSuccess`,
    CREATE_PARTNER_USER_FAILURE: `${uid}.createPartnerUserFailure`,
};

export { ActionTypes };
